module.exports = __webpack_public_path__ + "img/art-3-2.bf8f4690.jpg";